import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Gestión de foco en navegación SPA (Resolución 1519, Anexo 1 — CC16/CC17/CC23).
 *
 * En una SPA, cambiar de ruta NO recarga la página, por lo que los lectores de
 * pantalla no anuncian el cambio ni reposicionan el foco. Este componente, en cada
 * cambio de ruta, mueve el foco al landmark <main> (que tiene tabIndex={-1}) y sube
 * el scroll al inicio, de modo que la lectura comience desde el contenido principal.
 */
const RouteFocus = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const main = document.getElementById('contenido-principal');
    if (main) main.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default RouteFocus;
